
// window._ = require('lodash');

window.$ = window.jQuery ?  window.jQuery : require('jquery');

// window.swal = require('sweetalert2');

// require('fitvids')();

// require('jquery-parallax.js')

import Vue from 'vue';

Vue.component('resume', require('./Resume'))
Vue.component('popdown', require('./PopDown'))
new Vue({
  el: '#app'
});

// require('./magicline')
// window.$('#main-nav-ul').magicLine();

// Vue.use(require('vee-validate'), {fieldsBagName: 'formFields'});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
// var ES6Promise = require("es6-promise");
// ES6Promise.polyfill();

// window.axios = require('axios');
//
// window.axios.defaults.headers.common = {
//     'X-WP-Nonce': wpApiSettings.nonce,
//     'X-Requested-With': 'XMLHttpRequest'
// };
// window.axios.defaults.baseURL = wpApiSettings.root



// WEBPACK FOOTER //
// ./assets/js/bootstrap.js